/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

interface ShowTypeMenuItem {
  title: string;
  iconName: string;
  type: 'inbox' | 'passed' | 'done';
}

@Component({
  moduleId: module.id,
  selector: 'gh-todo-type-menu',
  template: require('./todo-type-menu.component.html'),
  styles: [require('./todo-type-menu.component.scss')],
})
export class TodoTypeMenuComponent implements OnInit {
  @Input() currentShowType: string = 'inbox';
  @Input() menuItems: ShowTypeMenuItem[] = [];
  @Output() changeShowType: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {
  }

  onChangeShowType(type: string): void {
    this.changeShowType.emit(type);
  }

  iconName(name: string): string {
    return `gh:${name}`;
  }

}
